import { ProjectOnboardingTask } from "../../onboarding/model/projectOnboardingTask";
import { OnboardingCall } from "../../onboarding/model/stepMeeting";

export class ProjectSettingsData{
    testMode : boolean;
    testModeEnabled : boolean;
    showPoweredByMoonflow : boolean;
    poweredByMoonflowLink : string;
    projectPlanId: number;
    immediatePayment: boolean;
}

export enum ProjectType{
    CLIENTS = 'C',
    BUSINESS = 'B',
}


export enum TypeTemplateFile{
  PAYMENT_ORDER = 'P',
  CLIENT = 'C',
  PAYMENT_NOTIFICATION = 'R',
  CREDIT = 'Z',
  GLOBAL = 'G'
}

export enum OnboardingSampleDataCodeBase {
  BYS = 'BYS',
  FIN = 'FIN',
  BPO = 'BPO',
  REC = 'REC',
}

export class ProjectGeneralSessionData{
  onboardingCall: OnboardingCall
  onboardingCode : string;
  onboardingEnablePlatform: boolean;
  alertDisplayedChecklist: boolean;
  // onboardingEnablePreSetting: boolean;
  onboardingStatus: string;
  onboardingPercentage: number;
  onboardingProjectTasks: ProjectOnboardingTask[];
  dataDeleteProcessActive: boolean;
  strategyDeleteRecoveryProcessActive  : boolean
  onboardingProductionDate: Date;
  accountManagerName: string;
  onboardingSpecialistName: string;
  sendVersionConversationComponent : string;
}

export enum CalculateDueDateType{
  DEFAULT = 'D',
  EXACT = 'E',
}

export enum HierarchicalRelationEnum {
  DEFAULT = 'DEFAULT',
  LEVEL_2 = 'LEVEL_2',
}

export enum UnreportedAsPaidRecoveryType {
  UNREPORTED_AS_PAID_RECOVERY_ACTIVE_UNTIL_FINISH = 'A',
  UNREPORTED_AS_PAID_RECOVERY_FINISHED = 'F',
  UNREPORTED_AS_PAID_RECOVERY_PAID = 'P',
}